import React from 'react'
import { useState } from 'react';
import { Calendar, ChevronDown, ChevronUp } from 'lucide-react';
import { Col, Row, Tab, Accordion, ListGroup, Badge } from 'react-bootstrap';
import { useMyTask } from '../hooks/useMyTask'


function InProgres({ userId, role }) {
  const { isLoading, isError, error, data } = useMyTask(userId, role);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error: {error}</div>;
  }

  // Filter relevant projects
  const filteredProjects = data.filter(project =>
    project.tasks.some(task =>
      task.status === "in_progress" &&
      !task.completed &&
      task.role === role
    )
  );

  return (
    <div className="w-full max-w-3xl mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4 text-center text-gray-800">Projects and Tasks</h2>
      <p className="text-center mb-6 text-gray-600">Click on a project to see its tasks</p>

      {filteredProjects.length === 0 ? (
        <div className="text-center text-muted py-4">No projects' Task found.</div>
      ) : (
        <Accordion>
          {filteredProjects.map((project, index) => (
            <Accordion.Item key={project.project_id} eventKey={index.toString()} className="mb-3 border border-gray-300 rounded overflow-hidden">
              <Accordion.Header className="font-medium text-primary">
                {project.projectName}
                <span className="text-sm ml-2">
                  ({project.tasks.filter(task =>
                    task.status === "in_progress" &&
                    !task.completed &&
                    task.role === role
                  ).length} tasks)
                </span>
              </Accordion.Header>
              <Accordion.Body className="p-0">
                <ListGroup className="divide-y divide-gray-200">
                  {project.tasks
                    .filter(task =>
                      task.status === "in_progress" &&
                      !task.completed &&
                      task.role === role
                    )
                    .map(task => (
                      <ListGroup.Item key={task.taskId} className="p-3 hover-shadow">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="font-medium">{task.name}</div>
                          <div className="flex items-center gap-1">
                            <Calendar size={16} />
                            <Badge variant="primary">{formatDate(task.start)}</Badge>
                          </div>
                        </div>
                      </ListGroup.Item>
                    ))}
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      )}
    </div>
  );
}

export default InProgres;
